import React, { createContext, useState, useContext } from 'react'
import { Backdrop } from '@mui/material';


export const BackdropContext = createContext()

export function useBackdrop() {
    return useContext(BackdropContext)
}

export function BackdropProvider({
    children,
}) {
    const [backdrop, setBackdrop] = useState({
        open: false,
        render: null
    })

    const openBackdrop = (nextBackdrop) => {
        setBackdrop({
            open: true,
            render: nextBackdrop
        })
    }

    const closeBackdrop = () => {
        setBackdrop({
            open: false,
            render: null
        })
    }

 
    return (
        <BackdropContext.Provider
            value={{
                closeBackdrop,
                openBackdrop
            }}
        >
            {children}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, background: 'rgba(0,0,0,.9)'}}
                open={backdrop.open}
                onClick={() => { }}
            >
                 {backdrop.render}
            </Backdrop>
        </BackdropContext.Provider>
    )
}

